module.exports = __webpack_public_path__ + "img/uk-diabetes-mellitus-female.c49f7a30.png";